module.exports = __webpack_public_path__ + "static/media/chevron-right-icon.efae79d9.svg";